__turbopack_context__.v({
  "className": "ibmplexmonofont_30b21dd5-module__2bqlkq__className",
  "variable": "ibmplexmonofont_30b21dd5-module__2bqlkq__variable",
});
